'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAlign = textAlign;
function textAlign(align) {
  return align && (align === 'justify' ? 'justified' : align + ' aligned');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-vue/dist/commonjs/lib/textAlign.js
// module id = doYi
// module chunks = 0